import React, { FC, useMemo } from 'react'
import { observer } from 'mobx-react'
import { restaurantConfig } from 'restaurant'
import { classNames, format, toDecimal } from '@dt/fe-utils'
import { ProductImage, BagIcon, Tags, RequiredBadge } from 'components'
import DiscountTag from '../DiscountTag'
import './index.scss'

interface IProps {
  item: IViewCombinedCartItem | IViewCombinedOrderDetail;
  /** true 待确认 false 已下单 undefined|null 不显示 */
  // isWait?: true | false | undefined | null;
  /** 餐品状态 待下单 待确认 已下单 （无状态） */
  status?: 'WAIT_PLACE' | 'WAIT_CONFRIM' | 'ORDERED' | '';
}

const MultiProductItem: FC<IProps> = ({ item, status }) => {
  const refundCnt = (item as IViewCombinedOrderDetail).refundCnt || 0
  const isAllRefund = (item as IViewCombinedOrderDetail).isAllRefund
  const productGroup = (item: IViewCombinedCartItem | IViewCombinedOrderDetail) => {
    return (
      <div className='item-groups'>
        {
          item.productGroups?.map(group => (
            <div key={group.no} className='item-group'>
              {
                group?.productGroupDetails.map(product => (
                  <div key={product.pk} className='item-group-product'>
                    <div className='product-info'>
                      <strong>{product.name}</strong>
                      <br />
                      <small>{product.optionStr}</small>
                      <div className='product-extra-info'>
                        <Tags datas={[...(product.tags || []), ...(product.allergys || [])]} />
                      </div>
                    </div>
                    <div className='product-cnt'>x {product.cnt}</div>
                  </div>
                ))
              }
            </div>
          ))
        }
      </div>
    )
  }

  const statusName = useMemo(() => {
    if (!status) return ''
    return isAllRefund && refundCnt ? i18n.t('checkout.refunded') : status === 'WAIT_CONFRIM' ? i18n.t('checkout.unconfirmed') : status === 'ORDERED' ? '' : i18n.t('checkout.unorder')
  }, [item, status])

  const renderItem: any = (isRefund: boolean, totalPrice?: number) => {
    return (
      <div
        className={classNames('checkout-product-item', {
          'refund-item': isRefund,
          'ordered-item': status === 'ORDERED',
        })}
      >
        <div className='item-top'>
          <div className='checkout-product-img-wrap'>
            <ProductImage color={!item.pic && restaurantConfig.displayMode === 'waterfall' ? item.productNo : ''} width={64} imgSrc={item.pic} cnt={isRefund ? 0 : item.cnt} />
            {item.isRequired && <RequiredBadge />}
          </div>
          <div className='item-info'>
            <span className='item-title'>{!!item.isTogo && <BagIcon size='small' />}{item.name}</span>
            <br />
            <small>{item.optionStr}</small>
            <div className='product-extra-info'>
              <Tags datas={[...(item.tags || []), ...(item.allergys || [])]} disableSingleSale={!(item as IViewCombinedCartItem).isSingleSale} />
            </div>
          </div>
          <div className='product-price'>
            <div className='price' dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(totalPrice !== undefined ? totalPrice : item.actualPrice) }}></div>
            {
              isRefund ? null : (
                <div className='item-discount'>
                  <DiscountTag offItems={item.offItems} />
                </div>
              )
            }
            {isRefund ? null : item.actualPrice !== item.totalPrice ? <del dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(item.totalPrice) }}></del> : ''}
          </div>
        </div>
        {productGroup(item)}
        {isRefund ? null : !!item.remark && <div className='remark-txt-wrap'>{i18n.t('cart.singleRemarkTxt')}{item.remark}</div>}
        {isRefund ? <div className='item-staus'><span><em>{i18n.t('checkout.refunded')}</em></span></div> : !!statusName && <div className='item-staus'><span><em>{statusName}</em></span></div>}
      </div>
    )
  }

  return (
    <>
      {!isAllRefund && refundCnt > 0 ? renderItem(true, toDecimal(item.totalPrice / item.cnt * refundCnt, 2)) : null}
      {renderItem(isAllRefund && refundCnt > 0)}
    </>
  )
}

export default observer(MultiProductItem)
